import "./buttonadmin.css";
import Button from "../../Custom/Button/Button";
import { useEffect } from "react";

const ButtonAdmin = ({
  data,
  slideButton,
  position,
  handleActive,
  handleNotActive,
  handleActivation,
}) => {
  const { active, picture } = data;

  const setTime = (bool) => {
    const currentDate = new Date();
    const day = currentDate.getDate();
    const month = currentDate.getMonth() + 1;
    const year = currentDate.getFullYear();
    const hours = currentDate.getHours();
    const minutes = currentDate.getMinutes();
    let correctHours = hours.toString().charAt(1) === "" ? `0${hours}` : hours;
    document.querySelector(".hours").innerHTML = correctHours;
    document.querySelector(".doubledot").style.opacity = `${bool ? "1" : "0"}`;
    let correctMinutes =
      minutes.toString().charAt(1) === "" ? `0${minutes}` : minutes;
    document.querySelector(".minutes").innerHTML = correctMinutes;
    let correctDay = day.toString().charAt(1) === "" ? `0${day}` : day;
    document.querySelector(".current-day").innerHTML = correctDay;
    let correctMonth = month.toString().charAt(1) === "" ? `0${month}` : month;
    document.querySelector(".current-month").innerHTML = correctMonth;
    let correctYear = year.toString().charAt(2);
    correctYear += year.toString().charAt(3);
    document.querySelector(".current-year").innerHTML = correctYear;
  };

  useEffect(() => {
    if (position === 9) {
      let bool = true;
      setTime(bool);
      let interval = setInterval(() => {
        bool = !bool;
        setTime(bool);
      }, 1000);
      return () => {
        clearInterval(interval);
      };
    }
  }, []);

  return (
    <div
      className="button-picture"
      onClick={
        slideButton[position].active === 0
          ? () => handleActive(position)
          : () => handleNotActive(position)
      }
    >
      {data.name === "NOTIFICATION" ? (
        <Button active={active} activation={() => handleActivation(position)}>
          <div className="prvi-div">
            <div className="time">
              <div className="hours" />
              <div className="doubledot">:</div>
              <div className="minutes" />
            </div>
            <div className="current-date">
              <div className="current-day" />
              <div className="time-dot">.</div>
              <div className="current-month" />
              <div className="time-dot">.</div>
              <div className="current-year" />
            </div>
          </div>
        </Button>
      ) : (
        <Button
          active={active}
          image={picture}
          activation={() => handleActivation(position)}
        />
      )}
    </div>
  );
};

export default ButtonAdmin;
